import schedulesLocale from 'modules/schedules/presentation/locale';
import schedulesRoutes from 'modules/schedules/presentation/routes';

const schedulesModule = {
  locale: schedulesLocale,
  routes: schedulesRoutes,
};

export default schedulesModule;
